import classes from 'components/common/WidgetWithTitle/Separator/separator.module.scss';

export const Separator = ({ className = '' }) => {
    return <div className={`${classes.separator} ${className}`} />;
};
